export const NOTIFICATIONS = {
        bell: 'notification-bell',
        badge: 'notification-badge',
        page: 'notifications-page',
        item: 'notification-item',
        markAllBtn: 'notification-mark-all',
        empty: 'notifications-empty',
        // admin send
        adminPage: 'admin-notifications-page',
        target: 'notif-target-type',
        role: 'notif-role',
        user: 'notif-user-id',
        title: 'notif-title',
        message: 'notif-message',
        sendBtn: 'notif-send',
};
